<template>
	<div class="settings">
			<!-- Настройки автозапуска -->
			<div class="settings-section" v-if="activeSettingsItem === 0">
				<div class="options-panel_head">
					<div class="s-title text-green">
						Настройки автозапуска двигателя автомобиля
					</div>
					<p class="text-base">
						<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
					</p>
				</div>
				<div class="style-hr__solid">
				</div>

				<perfect-scrollbar>
					<div class="settings-content">
						<div class="settings-content_col">
							<div class="settings-operation">
								<button class="btn btn-clean btn-brd"
												v-on:click="addAutostart()"
												v-bind:disabled="timers.list.length > 13">
									Добавить запуск по расписанию
								</button>
							</div>
							<div class="autostart-list">
								<div class="autostart-list_item"
										 v-for="(timer, timerIndex) in timers.list"
										 v-bind:key="timerIndex">
									<div class="autostart-status">
										<input v-model="timer.name" class="autostart-name" placeholder="Название автозапуска">
										<label class="switcher">
											<input type="checkbox" v-model="timer.status">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
									<div class="autostart-item_cnt"
											 v-bind:class="{ 'autostart-item_cnt__passive' : timer.status == 0 }">
										<div class="autostart-time">
											<label>
												<masked-input v-model="timer.hours" mask="11" maxlength="2" placeholder="XX"
                                      class="field-time_hour" v-on:keyup.native="changeTime( timerIndex, 'hours' )">
												</masked-input>
												<span>:</span>
												<masked-input v-model="timer.minutes" mask="11" maxlength="2" placeholder="XX" class="field-time_minute" v-on:keyup.native="changeTime( timerIndex, 'minutes' )">
												</masked-input>
											</label>
										</div>
										<div class="autostart-days">
											<div class="autostart-days_item"
													 v-for="(dayWeek, indexDay) in timer.days"
													 v-bind:key="indexDay"
													 v-bind:class="{ 'autostart-days_item__active' : dayWeek == '1' }"
													 v-on:click="toggleActiveDay( timerIndex, indexDay )">
												{{timers.nameDaysWeek[indexDay]}}
											</div>
										</div>
										<div class="text-right">
											<a href="javascript:void(0)" class="btn btn-clean" v-on:click="delAutostart( timerIndex )">Удалить автозапуск</a>
										</div>
										<div class="style-hr__solid">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="settings-content_separator">
						</div>
						<div class="settings-content_col">
							<div class="settings-content_subtitle">
								Время работы двигателя при автозапуске:
							</div>
							<div class="list-times">
								<div class="list-times_item"
										 v-for="(numMinut, indexMinut) in timers.timerstart"
										 v-bind:class="{'list-times_item__active' : numMinut === allSettings.timerstart }"
										 v-bind:key="indexMinut"
										 v-on:click="changeMinut(numMinut, 'timerstart')" >
									<span>{{numMinut}} минут</span>
								</div>
							</div>
							<div class="settings-content_subtitle">
								Время работы двигателя в режиме пит стоп:
							</div>
							<div class="list-times">
								<div class="list-times_item"
										 v-for="(numMinut, indexMinut) in timers.timerpit"
										 v-bind:class="{'list-times_item__active' : numMinut === allSettings.timepit }"
										 v-bind:key="indexMinut"
										 v-on:click="changeMinut(numMinut, 'timepit')" >
									<span>{{ parseInt(numMinut) }} минут</span>
								</div>
							</div>

							<div v-if="allSettings.batterycharge">

								<div class="form-item">
									<div class="slidebar-title">
										Запуск, если температура двигателя стала ниже
										<label class="switcher">
											<input type="checkbox" v-model="allSettings.cbstartonlowtemp">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
									<div v-bind:class="{ 'sliderDisabled' : !allSettings.cbstartonlowtemp }">
										<vue-slider
												ref="slider"
												v-model="allSettings.tempengine"
												v-bind="common.sliders.tempengine"
										></vue-slider>
										<div class="slidebar_sensivity text-small">
											<span>{{allSettings.tempengine}}°C</span>
										</div>
									</div>
								</div>
								<!-- -->
								<div class="form-item">
									<div class="slidebar-title">
										Запуск, если температура салона стала ниже
										<label class="switcher">
											<input type="checkbox" v-model="allSettings.cbstartonlowtempcabin">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
									<div v-bind:class="{ 'sliderDisabled' : !allSettings.cbstartonlowtempcabin }">
										<vue-slider
												ref="slider"
												v-model="allSettings.tempcabinlow"
												v-bind="common.sliders.tempcabinlow"
										></vue-slider>
										<div class="slidebar_sensivity text-small">
											<span>{{allSettings.tempcabinlow}}°C</span>
										</div>
									</div>
								</div>
								<!-- -->
								<div class="form-item">
									<div class="slidebar-title">
										Запуск, если температура салона стала выше
										<label class="switcher">
											<input type="checkbox" v-model="allSettings.cbstartonhightempcabin">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
									<div v-bind:class="{ 'sliderDisabled' : !allSettings.cbstartonhightempcabin }">
										<vue-slider
												ref="slider"
												v-model="allSettings.tempcabinhigh"
												v-bind="common.sliders.tempcabinhigh"
										></vue-slider>
										<div class="slidebar_sensivity text-small">
											<span>{{allSettings.tempcabinhigh}}°C</span>
										</div>
									</div>
								</div>
								<!-- -->
								<div class="form-item">
									<div class="slidebar-title">
										Запуск, если бортовое напряжение стало ниже
										<label class="switcher">
											<input type="checkbox" v-model="allSettings.cbstartonlowbattery">
											<div class="switcher_checked">
												<div class="switcher_status">
												</div>
											</div>
											<div class="switcher_toddler">
											</div>
										</label>
									</div>
									<div v-bind:class="{ 'sliderDisabled' : !allSettings.cbstartonlowbattery }">
										<vue-slider
												ref="slider"
												v-model="allSettings.batterycharge"
												v-bind="common.sliders.batterycharge"
										></vue-slider>
										<div class="slidebar_sensivity text-small">
											<span>{{allSettings.batterycharge}}V</span>
										</div>
									</div>
								</div>
							</div>

              <label class="settings-content_subtitle">
                Запрет автоматических запусков
                <div class="checkbox">
                  <input type="checkbox" v-model="allSettings.cbautostartdisable">
                  <div class="checkbox_img">
                  </div>
                </div>
              </label>
							<label class="settings-content_subtitle">
								Турбо-таймер
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cbturbotimer">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<label class="settings-content_subtitle">
								Голосовые оповещения от системы
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cballowvoicehints">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<label class="settings-content_subtitle">
								Световая индикация
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cblightsonalarm">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<label class="settings-content_subtitle">
								Выключить двигатель при снятии с охраны
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cbstopengineondisarm">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<label class="settings-content_subtitle">
								Разрешить тревогу по датчику удара
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cbignonshockenable">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<label class="settings-content_subtitle">
								Запирать замки после автозапуска
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cbdoorlockafterrstart">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<div class="settings-content_subtitle">
								<span class="text-color-base-b2">Подготовка к запуску для МКПП</span>
							</div>
							<label class="settings-content_subtitle">
								Поддержка зажигания при включении ручника
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cbignsupphbrake">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<label class="settings-content_subtitle">
								Поддержка зажигания при открытии двери
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cbignsuppondooropen">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
							<label class="settings-content_subtitle">
								Выключение поддержки зажигания при закрытии двери
								<div class="checkbox">
									<input type="checkbox" v-model="allSettings.cbenginestopdoor">
									<div class="checkbox_img">
									</div>
								</div>
							</label>
						</div>
					</div>
				</perfect-scrollbar>
			</div>
			<!-- Уведомления от охранной системы -->
			<div class="settings-section" v-if="activeSettingsItem === 1">
				<div class="options-panel_head">
					<div class="s-title text-green">
						Уведомления от охранной системы
					</div>
					<p class="text-base">
						<!--Текстовое описание процеса автозапуска двигателя, настройки расписания и рекомендуемых параметров работы.-->
					</p>
				</div>
				<div class="style-hr__solid">
				</div>

				<perfect-scrollbar>
					<div class="settings-content">
						<div class="settings-content_col settings-content_col__space">
							<div class="notification-menu">
								<div class="notification-menu_title">
									Фильтр событий для оповещений
								</div>
								<!-- Email -->
								<div class="notification-menu_item"
										 v-on:click="changeNotifCurrent('Email')"
										 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'Email' }">
									<div>
										Уведомления по e-mail
										<div class="text-small">{{user.data.email}}</div>
									</div>
								</div>
								<!-- Push -->
								<div class="notification-menu_item"
										 v-on:click="changeNotifCurrent('Push')"
										 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'Push' }">
									<span>Push уведомления в приложении</span>
								</div>
								<div class="notification-menu_title">
									Фильтр событий для оповещений на телефонные номера
								</div>
								<!-- Phone1 -->
								<div class="notification-menu_item notification-menu_item__phone">
									<span class="notification-menu_phone notification-menu_phone__number"
												v-if="notification.car.phone_1 && !notification.change.p1">{{ notification.car.phone_1 }}</span>
									<masked-input
											v-else-if="notification.change.p1"
											v-model="notification.car.phone_1" mask="+11111111111" placeholder="+71234567890" type="tel" />
									<span class="notification-menu_phone"
												v-else>Телефон не указан</span>

									<span class="change-phone"
												v-if="notification.change.p1"
												v-on:click='saveNotifPhone("p1")'>Сохранить</span>
									<span class="change-phone"
												v-on:click="changePhone('p1')"
												v-else>Изменить</span>
								</div>

								<div v-if="notification.car.phone_1 && !notification.change.p1">
									<div class="notification-menu_phone-notif"
											 v-on:click="changeNotifCurrent('P1C')"
											 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P1C' }">
										<span class="notification-menu-icon icon-phone"></span>
										Звонки на телефон
									</div>
									<div class="notification-menu_phone-notif"
											 v-on:click="changeNotifCurrent('P1S')"
											 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P1S' }">
										<span class="notification-menu-icon icon-sms"></span>
										SMS уведомления
									</div>
								</div>
								<!-- Phone2-->
								<div class="notification-menu_item notification-menu_item__phone">
									<span class="notification-menu_phone notification-menu_phone__number"
												v-if="notification.car.phone_2 && !notification.change.p2">{{ notification.car.phone_2 }}</span>
									<masked-input v-else-if="notification.change.p2"
																v-model="notification.car.phone_2" mask="+11111111111" placeholder="+71234567890" type="tel" />
									<span class="notification-menu_phone"
												v-else>Телефон не указан</span>

									<span class="change-phone"
												v-if="notification.change.p2"
												v-on:click='saveNotifPhone("p2")'>Сохранить</span>
									<span class="change-phone"
												v-on:click="changePhone('p2')"
												v-else>Изменить</span>
								</div>
								<div v-if="notification.car.phone_2 && !notification.change.p2">
									<div class="notification-menu_phone-notif"
											 v-on:click="changeNotifCurrent('P2C')"
											 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P2C' }">
										<span class="notification-menu-icon icon-phone"></span>
										Звонки на телефон
									</div>
									<div class="notification-menu_phone-notif"
										 v-on:click="changeNotifCurrent('P2S')"
										 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P2S' }">
									<span class="notification-menu-icon icon-sms"></span>
									SMS уведомления
								</div>
								</div>
								<!-- Phone3 -->
								<div class="notification-menu_item notification-menu_item__phone">
									<span class="notification-menu_phone notification-menu_phone__number"
												v-if="notification.car.phone_3 && !notification.change.p3">{{ notification.car.phone_3 }}</span>
									<masked-input v-else-if="notification.change.p3"
																v-model="notification.car.phone_3" mask="+11111111111" placeholder="+71234567890" type="tel" />
									<span class="notification-menu_phone"
												v-else>Телефон не указан</span>

									<span class="change-phone"
												v-if="notification.change.p3"
												v-on:click='saveNotifPhone("p3")'>Сохранить</span>
									<span class="change-phone"
												v-on:click="changePhone('p3')"
												v-else>Изменить</span>
								</div>
								<div v-if="notification.car.phone_3 && !notification.change.p3">
									<div class="notification-menu_phone-notif"
											 v-on:click="changeNotifCurrent('P3C')"
											 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P3C' }">
										<span class="notification-menu-icon icon-phone"></span>
										Звонки на телефон
									</div>
									<div class="notification-menu_phone-notif"
										 v-on:click="changeNotifCurrent('P3S')"
										 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P3S' }">
									<span class="notification-menu-icon icon-sms"></span>
									SMS уведомления
								</div>
								</div>
								<!-- Phone4 -->
								<div class="notification-menu_item notification-menu_item__phone">
									<span class="notification-menu_phone notification-menu_phone__number"
												v-if="notification.car.phone_4 && !notification.change.p4">{{ notification.car.phone_4 }}</span>
									<masked-input v-else-if="notification.change.p4"
																v-model="notification.car.phone_4" mask="+11111111111" placeholder="+71234567890" type="tel" />
									<span class="notification-menu_phone"
												v-else>Телефон не указан</span>

									<span class="change-phone"
												v-if="notification.change.p4"
												v-on:click='saveNotifPhone("p4")'>Сохранить</span>
									<span class="change-phone"
												v-on:click="changePhone('p4')"
												v-else>Изменить</span>
								</div>
								<div v-if="notification.car.phone_4 && !notification.change.p4">
									<div class="notification-menu_phone-notif"
												v-on:click="changeNotifCurrent('P4C')"
												v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P4C' }">
										<span class="notification-menu-icon icon-phone"></span>
										Звонки на телефон
									</div>
									<div class="notification-menu_phone-notif"
										 v-on:click="changeNotifCurrent('P4S')"
										 v-bind:class="{ 'notification-menu_phone-notif__active' : notification.current === 'P4S' }">
									<span class="notification-menu-icon icon-sms"></span>
									SMS уведомления
								</div>
								</div>
							</div>
						</div>
						<div class="settings-content_separator">
						</div>
						<div class="settings-content_col">
							<!-- Details -->
							<div class="notification-details">
								<label v-for="item in notifDetails"
										  class="notification-details_item">
									<span>{{item.name}} : </span>
									<div class="checkbox">
										<input type="checkbox"
													 v-model="item.val"
													 v-on:change="changeNotifDetails(item)">
										<div class="checkbox_img"></div>
									</div>
								</label>
							</div>
						</div>
					</div>
				</perfect-scrollbar>
			</div>
			<!-- Общие настройки -->
			<div class="settings-section" v-if="activeSettingsItem === 2">
				<div class="options-panel_head">
					<div class="s-title text-green">
						Общие настройки
					</div>
					<p class="text-base">
						<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
					</p>
				</div>
				<div class="style-hr__solid">
				</div>
				<perfect-scrollbar>
					<div class="settings-content">
						<div class="settings-content_col settings-content_col__space">
							<!-- -->
							<div class="generalSettings_list">
								<div class="generalSettings_list-item">
									<div class="generalSettings_name">
										Серийный номер
									</div>
									<div class="generalSettings_value">
										{{generalSettings.serial}}
									</div>
								</div>
								<div class="generalSettings_list-item">
									<div class="generalSettings_name">
										Дата выпуска
									</div>
									<div class="generalSettings_value">
										{{generalSettings.created | moment("DD.MM.YYYY") }}
									</div>
								</div>
							</div>
							<div class="form-item">
								<div class="form-title">
									Номер сим.карты
								</div>
								<label class="form-control form-control__empty">
									<input type="text" class="form-field" placeholder="+71234567890" v-model="generalSettings.msisdn">
								</label>
							</div>
							<div class="form-item">
								<div class="form-title">
									Код для выполнения команд через голосовое меню
								</div>
								<label class="form-control form-control__empty">
									<input type="text" class="form-field" placeholder="0069" v-model="generalSettings.pin">
								</label>
							</div>
							<div class="form-item">
								<div class="form-title">
									Телефон технической поддержки
								</div>
								<label class="form-control form-control__empty">
									<input type="text" class="form-field" placeholder="+78000000000" v-model="generalSettings.tehsupport">
								</label>
							</div>
							<div class="form-item">
								<div class="form-title">
									Телефон экстренной службы
								</div>
								<label class="form-control form-control__empty">
									<input type="text" class="form-field" placeholder="112" v-model="generalSettings.emergency">
								</label>
							</div>
							<!-- -->

							<!-- Тариф -->
							<div  v-if="tarif.list.length">
								<div class="tarif"
										 v-if="tarif.current !== 'none' && tarif.balance !== 'none'">
									<div class="tarif-line">
										<div class="tarif-name">
											Тариф «{{tarif.current.name}}»
										</div>
										<div class="tarif-change" v-on:click="common.genOptions = 2">
											Сменить
										</div>
									</div>
									<div class="tarif-line">
										<div>
											Баланс
										</div>
										<div class="text-small">
											{{tarif.balance.balance}}
											&#8381;
										</div>
									</div>
									<div class="tarif-line tarif-line__no-padd">
										<div class="tarif-line_item">
											<div class="tarif-line_item-name">
												Интернет
											</div>
											<div class="tarif-line_item-val">
												<span v-if="tarif.current.internet.out_free_cnt">{{tarif.current.internet.out_free_cnt}} Мб</span>
												<span>{{tarif.current.internet.out_price}}  &#8381;/Мб</span>
											</div>
										</div>
										<div class="tarif-line_item">
											<div class="tarif-line_item-name">
												Минуты
											</div>
											<div class="tarif-line_item-val">
												<span v-if="tarif.current.call.out_free_cnt">{{tarif.current.call.out_free_cnt}} мин</span>
												<span>{{tarif.current.call.out_price}}  &#8381;/мин</span>
											</div>
										</div>
										<div class="tarif-line_item">
											<div class="tarif-line_item-name">
												SMS
											</div>
											<div class="tarif-line_item-val">
												<span v-if="tarif.current.sms.out_free_cnt">{{tarif.current.sms.out_free_cnt}}</span>
												<span>{{tarif.current.sms.out_price}}  &#8381;</span>
											</div>
										</div>
									</div>
								</div>
								<div class="tarif" v-else>
									<div class="tarif-line">
										<div class="tarif-name">
											Тариф не выбран
										</div>
										<div class="tarif-change" v-on:click="common.genOptions = 2">
											Выбрать
										</div>
									</div>
								</div>
								<div class="form-item">
									<div class="style-hr style-hr__solid">
									</div>
								</div>
							</div>
							<!-- -->

							<!-- Паспортные данные -->
							<div v-if="passport.access !== 2">
								<div class="settings-content_subtitle">
									<span class="text-color-base-b2">Паспортные данные владельца SIM карты устройства</span>
								</div>
								<div class="form-item">
									<div class="passport-sim_passport">Паспорт **** ******</div>
									<a v-on:click="common.genOptions = 1" class="text-orange">Редактировать</a>
								</div>
								<div class="form-item">
									<div class="style-hr style-hr__solid">
									</div>
								</div>
							</div>
							<!-- end Паспортные данные -->

							<!-- start Обновление ПО -->
							<div v-if="listCar[currentCar.index].access_firmware">
								<div class="settings-content_subtitle">
									<span class="text-color-base-b2">Програмное обеспечение</span>
								</div>
								<div v-if="firmware.status.need">
									<div class="firmwareSettings_need" v-if="firmware.status.service !== 3">
										Вы иcпользуете устаревшую версию програмного обеспечения.
										Настоятельно рекомендуем вам обновить ваше ПО.
									</div>
									<!--<div class="settings-operation text-small" v-else>
										&lt;!&ndash; TODO установлено в устройстве &ndash;&gt;
									</div>-->
								</div>
								<div class="firmwareSettings_list">
									<div class="firmwareSettings_list-item"
											 v-for="(firmwareItem, firmwareIndex) in firmware.list"
											 v-bind:key="firmwareIndex"
											 v-bind:class="{ 'firmwareSettings_list-item__progress' : Number.isInteger(firmwareItem.progress),
																			 'firmwareSettings_list-item__available-update' : firmwareItem.update }">
										<div class="firmwareSettings_cnt">
											<div class="firmwareSettings_name">
												{{firmwareItem.pcb_name}}
											</div>
											<div class="firmwareSettings_hardcode" v-if="firmwareItem.current">
												{{firmwareItem.current.hard_code}}
											</div>
											<div class="firmwareSettings_progress" v-if="firmware.status.service === 2 && Number.isInteger(firmwareItem.progress)">
												<div class="firmwareSettings_progress-active" v-bind:style="{ width: firmwareItem.progress + '%' }">
												</div>
											</div>
										</div>
										<div class="firmwareSettings_update" v-if="firmwareItem.update">
											<div class="firmwareSettings_name">
												Есть обновление
											</div>
											<div class="firmwareSettings_hardcode">
												{{firmwareItem.update.hard_code}}
											</div>
											<div class="firmwareSettings_description">
												{{firmwareItem.update.description}}
											</div>
										</div>
									</div>
								</div>
								<div class="settings-operation" v-if="firmware.status.need === false">
									Установлена последняя версия
								</div>
								<div v-else>
									<div v-if="firmware.status.service === 0">
										<div class="settings-operation settings-operation__warning">
											На время установки ПО автомобиль необходимо перевести в режим "Автосервис"
										</div>
										<div class="firmwareSettings-process">
											<button class="btn btn-warning" v-on:click="sendCommand('service_start')">Автосервис</button>
										</div>
										<div class="settings-operation text-small">
											Снять режим "Автосервис" вы сможете вручную через дополнительные команды управления
										</div>
									</div>
									<div v-else-if="firmware.status.service === 1">
										<div class="settings-operation settings-operation__success">
											Автомобиль успешно переведен в режим «Автосервис». Теперь вы можете начать установку обновлений
										</div>
										<div class="form-item">
											<button class="btn btn-success" v-on:click="sendCommand('update_firmware')">Установить ПО</button>
										</div>
									</div>
									<div v-else-if="firmware.status.service === 2">
										<div class="settings-operation settings-operation__warning">
											Установка Обновлений может занять несколько минут. Пожалуйста, не совершайте никаких действий.
										</div>
									</div>
									<div v-else-if="firmware.status.service === 3">
										<div class="settings-operation settings-operation__success">
											Обновление успешно установлено.
											Теперь вы можете выйти из режима «Автосервис»
										</div>
										<div class="car-details_commands car-details_commands__settings">
											<div class="car-details_commands-cnt">
												<div class="car-details_commands-item" v-on:click="sendCommand('arm')">
													<div class="car-details_commands-img">
														<img src="../../assets/img/button/cmdGoArm.svg">
													</div>
													<div>
														Поставить
													</div>
													<div class="text-small">
														на охрану
													</div>
												</div>
												<div class="car-details_commands-item" v-on:click="sendCommand('disarm')">
													<div class="car-details_commands-img">
														<img src="../../assets/img/button/cmdDisarm.svg">
													</div>
													<div>
														Снять
													</div>
													<div class="text-small">
														с охраны
													</div>
												</div>
											</div>
										</div>
										<div class="settings-operation">
											Установлена последняя версия
										</div>
									</div>
									<div v-else-if="firmware.status.service === 4">
										<div class="settings-operation settings-operation__warning">
											Ошибка загрузки: Неизвестная ошибка
										</div>
									</div>
									<div v-else-if="firmware.status.service === 5">
										<div class="settings-operation settings-operation__warning">
											Ошибка загрузки: Превышено время ожидания
										</div>
									</div>
								</div>
							</div>
							<!-- end Обновление ПО -->
							<!-- start Калибровка топлива -->
							<div class="settings-content_subtitle">
								<span class="text-color-base-b2">Калибровка топлива</span>
							</div>
							<div v-if="fuelCalibration.status === true" class="fuelCalibration">
								<div class="settings-operation" v-if="fuelCalibration.calibration_info === 0">
									Калибровка не нужна
								</div>
								<div v-else>
									<div class="settings-operation settings-operation__warning" v-if="fuelCalibration.filling_state === null || fuelCalibration.filling_state === 0">
										Заправки отсутствуют. Необходимо провести 2 повторные заправки до полного бака
									</div>
									<div class="settings-operation settings-operation__warning" v-else-if="fuelCalibration.filling_state === 1">
										Заправка зафиксирована системой. Необходимо израсходовать не менее
										половины бака и провести повторную заправку "до полного"
									</div>
									<div class="settings-operation settings-operation__warning" v-else-if="fuelCalibration.filling_state === 2">
										Уровень топлива при повторной заправке отличается от предыдущего.
										Необходимо израсходовать не менее половины бака и провести повторную заправку "до полного"
									</div>
									<div class="settings-operation settings-operation__warning" v-else-if="fuelCalibration.filling_state === 3">
										Повторная заправка зафиксирована системой. Введите данные
										об объеме залитого топлива и объеме бака здесь или через мобильное приложение
									</div>
									<div class="fuelCalibration_instruction">
										1) Залейте на колонке топливо "до полного бака" (до автоматической отсечки пистолета).
										Программа сама запомнит максимальный уровень топлива в баке вашей машины
										(в этот момент ничего вводить не надо).<br>
										2) Израсходуйте залитое топливо в обычном режиме поездок.
										Израсходовать нужно не менее половины объема топливного бака
										(например, до включения лампочки резервного остатка топлива).<br>
										3) Еще раз залейте на колонке топливо "до полного бака"
										(до автоматической отсечки пистолета) и заполните поля, указанные ниже.
										Программа запомнит фактический расход топлива.<br>
									</div>
									<div class="fuelCalibration_title">
										Данные для калибровки
									</div>
									<form v-on:submit.prevent="sendfuelCalibration()">
										<div class="form-item">
											<div class="form-title">
												По чеку колонки залито
											</div>
											<label class="form-control form-control__empty">
												<input type="text" class="form-field" placeholder="Литры" v-model="fuelCalibration.filledup">
											</label>
										</div>
										<div class="form-item">
											<div class="form-title">
												Полный объем топливного бака
											</div>
											<label class="form-control form-control__empty">
												<input type="text" class="form-field" placeholder="Литры" v-model="fuelCalibration.fuel">
											</label>
										</div>
										<div class="fuelCalibration_submit">
											<button class="btn btn-success" type="submit">Отправить</button>
										</div>
									</form>
								</div>
							</div>
							<div v-else>
								<div class="settings-operation">
									Калибровка не нужна
								</div>
							</div>
							<!-- end Калибровка топлива -->
						</div>
						<div class="settings-content_separator">
						</div>
						<div class="settings-content_col">
							<!-- start Паспортные данные -->
							<div v-if="common.genOptions === 1">
								<div class="settings-content_subtitle">
									<span class="text-color-base-b2">Паспортные данные владельца SIM карты устройства</span>
								</div>
								<div class="passport-sim_attention">
									В соответствии с требованиями 126-ФЗ «О связи» Вам необходимо внести Ваши паспортные данные для использования установленной в телематическом устройстве UNIVERSE SIM-карты . Пожалуйста, не допускайте ошибок при вводе информации, в противном случае Вы не сможете пополнять счет, и SIM-карта будет блокирована.
								</div>
								<div class="form-item">
									<div class="form-title">
										Фамилия
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.last_name">
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Имя
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.first_name">
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Отчество
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.father_name">
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Дата рождения
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder=""
													 v-model="passport.data.birth_date"
													 v-on:focus="openDatapickerBirthdate"
													 v-on:blur="closeDatapickerBirthdate">
										<div class="form-control_datepicker" v-show="datepicker.birthDate.show">
											<datepicker
													ref="datepickerBirthDate"
													v-model="datepicker.birthDate.value"
													:language="datepicker.birthDate.lang.ru"
													:input-class="datepicker.birthDate.inputClass"
													:monday-first="true"
													@selected="datepickerFormatterBirthDate"
													:inline="true">
											</datepicker>
										</div>
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Страна выдачи паспорта
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.issue_country">
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Серия паспорта
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.passport_series">
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Номер паспорта
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.passport_number">
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Кем выдан
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.authority">
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Дата выдачи
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder=""
													 v-model="passport.data.issue_date"
													 v-on:focus="openDatapickerIssuedate"
													 v-on:blur="closeDatapickerIssuedate">
										<div class="form-control_datepicker" v-show="datepicker.issueDate.show">
											<datepicker
													ref="datepickerBirthDate"
													v-model="datepicker.issueDate.value"
													:language="datepicker.issueDate.lang.ru"
													:input-class="datepicker.issueDate.inputClass"
													:monday-first="true"
													@selected="datepickerFormatterIssuedate"
													:inline="true">
											</datepicker>
										</div>
									</label>
								</div>
								<div class="form-item">
									<div class="form-title">
										Код подразделения
									</div>
									<label class="form-control form-control__empty">
										<input type="text" class="form-field" placeholder="" v-model="passport.data.department_code">
									</label>
								</div>

								<label class="settings-content_subtitle">
									SIM карта приобретена мною самостоятельно
									или принадлежит не российскому оператору связи
									<div class="checkbox">
										<input type="checkbox" v-model="passport.data.is_personal_sim">
										<div class="checkbox_img"></div>
									</div>
								</label>
								<label class="settings-content_subtitle">
									<div>
										Даю согласие на обработку персональных
										данных в соответствии с <a href="https://mf-t.ru/consent_to_the_processing_of_personal_data.PDF" target="_blank">Соглашением</a>.
									</div>
									<div class="checkbox">
										<input type="checkbox" v-model="passport.is_accepted">
										<div class="checkbox_img"></div>
									</div>
								</label>
								<div class="form-item fuelCalibration_submit">
									<button
											class="btn btn-success"
											type="submit"
											:disabled="!passport.is_accepted"
											v-on:click="sendPersonalData">Отправить</button>
								</div>
							</div>
							<!-- end Паспортные данные -->
							<!-- start Тарифы -->
							<div v-if="common.genOptions === 2 && tarif.list.length">
								<div class="tarif-item"
										 v-for="item in tarif.list">
									<div class="tarif-line tarif-line__head">
										<div class="tarif-name">
											Тариф «{{item.name}}»
										</div>
									</div>
									<div class="tarif-option">
										<i class="tarif-option_icon icon-internet"></i>
										<div class="tarif-option_title">
											Интернет
										</div>
										<div class="tarif-option_line" v-if="item.internet.out_free_cnt">
											<div class="tarif-option_name text-small">
												Объем мобильного интернета(МБ)
											</div>
											<div class="tarif-option_val">
												{{item.internet.out_free_cnt}}
											</div>
										</div>
										<div class="tarif-option_line">
											<div class="tarif-option_name text-small">
												Мобильный интернет по тарифу или сверх пакета(за МБ)
											</div>
											<div class="tarif-option_val">
												{{item.internet.out_price}} &#8381;
											</div>
										</div>
										<div class="tarif_additional">
											<div class="text-small"
													 v-for="(adit, aditIndex) in item.internet.additional">
												<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
												{{adit.text}}
												<a v-if="adit.type === 'tariff_link'"
													 target="_blank"
													 v-bind:href="adit.val">{{adit.val}}</a>
											</div>
										</div>
									</div>
									<div class="tarif-option">
										<i class="tarif-option_icon icon-sms"></i>
										<div class="tarif-option_title">
											СМС сообщения
										</div>
										<div class="tarif-option_line" v-if="item.sms.out_free_cnt">
											<div class="tarif-option_name text-small">
												Включенный объем сообщений в месяц
											</div>
											<div class="tarif-option_val">
												{{item.sms.out_free_cnt}}
											</div>
										</div>
										<div class="tarif-option_line">
											<div class="tarif-option_name text-small">
												На все номера по тарифу или сверх пакета
											</div>
											<div class="tarif-option_val">
												{{item.sms.out_price}} &#8381;
											</div>
										</div>
										<div class="tarif_additional">
											<div class="text-small"
													 v-for="(adit, aditIndex) in item.sms.additional">
												<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
												{{adit.text}}
												<a v-if="adit.type === 'tariff_link'"
													 target="_blank"
													 v-bind:href="adit.val">{{adit.val}}</a>
											</div>
										</div>
									</div>
									<div class="tarif-option">
										<i class="tarif-option_icon icon-telephone"></i>
										<div class="tarif-option_title">
											Звонки
										</div>
										<div class="tarif-option_line" v-if="item.call.out_free_cnt">
											<div class="tarif-option_name text-small">
												Включенный объем минут в месяц на номера РФ
											</div>
											<div class="tarif-option_val">
												{{item.call.out_free_cnt}}
											</div>
										</div>
										<div class="tarif-option_line">
											<div class="tarif-option_name text-small">
												На все номера РФ по тарифу или сверх пакета
											</div>
											<div class="tarif-option_val">
												{{item.call.out_price}} &#8381;
											</div>
										</div>
										<div class="tarif_additional">
											<div class="text-small"
													 v-for="(adit, aditIndex) in item.call.additional">
												<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
												{{adit.text}}
												<a v-if="adit.type === 'tariff_link'"
													 target="_blank"
													 v-bind:href="adit.val">{{adit.val}}</a>
											</div>
										</div>
									</div>
									<div class="tarif_additional">
										<div class="text-small"
												 v-for="(adit, aditIndex) in item.additional">
											<span v-for="aster in aditIndex+1" v-bind:key="aster">*</span>
											{{adit.text}}
											<a v-if="adit.type === 'tariff_link'"
												 target="_blank"
												 v-bind:href="adit.val">{{adit.val}}</a>
										</div>
									</div>
									<div class="tarif-line">
										<div v-if="item.subscription">
											<span class="tarif-title tarif-title__line"><b>{{item.subscription}}</b> &#8381;</span> / месяц
										</div>
										<div v-else>
											<b>Без абонентской платы</b>
										</div>
										<div v-if="tarif.current !== 'none'">
											<button class="btn btn-disable"
															v-if="item.id === tarif.current.id"
															disabled="disabled">Тариф подключен</button>
											<button class="btn btn-warning"
															v-else
															v-on:click="changeTarif(item.id)">перейти на тариф</button>
										</div>
										<button class="btn btn-warning"
														v-else
														v-on:click="changeTarif(item.id)">перейти на тариф</button>
									</div>
								</div>
							</div>
							<!-- end Тарифы -->
						</div>
					</div>
				</perfect-scrollbar>
			</div>
			<!-- Автомобиль на карте -->
			<div class="settings-section" v-if="activeSettingsItem === 3">
				<div class="options-panel_head">
					<div class="s-title text-green">
						Автомобиль на карте
					</div>
					<p class="text-base">
						<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
					</p>
				</div>
				<div class="style-hr__solid">
				</div>

				<perfect-scrollbar>
					<div class="settings-content">
					</div>
				</perfect-scrollbar>
			</div>
			<!-- Параметры охранной системы -->
			<div class="settings-section" v-if="activeSettingsItem === 4">
				<div class="options-panel_head">
					<div class="s-title text-green">
						Параметры охранной системы
					</div>
					<p class="text-base">
						<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
					</p>
				</div>
				<div class="style-hr__solid">
				</div>

				<perfect-scrollbar>
					<div class="settings-content">
					<div class="settings-content_col settings-content_col__space">
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Отпирание и запирание дверей</span>
						</div>
						<label class="settings-content_subtitle">
							Приоритетное отпирание двери водителя
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbsequnlock">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Запирание дверей при начале движения
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cblockonmove">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Запирание дверей при включении двигателя
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cblockonengine">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Отпирать замки дверей при открытии одной
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbunlockondooropen">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Отпирать капот в сервисном режиме
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbservicehoodopen">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Запирание дверей после закрытия багажника
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cblockaftertrunk">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Постановка и снятие с охраны</span>
						</div>
						<label class="settings-content_subtitle">
							Разрешена автопостановка
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbselfarm">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Автопостановка/Автоснятие со звуком
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbselfarmsound">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Звуковой сигнал при постановке и снятии
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbsoundonarm">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Световой сигнал при постановке и снятии
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cblightsonarm">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Тревога</span>
						</div>
						<label class="settings-content_subtitle">
							Звуковой сигнал
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbsoundonalarm">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Световой сигнал
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cblightsonalarm">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Звук сирены при ударе
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbsoundonimpact">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Получать SMS с координатами события
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbsmscoordenable">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<div class="settings-content_subtitle">
							Длительность тревоги:
						</div>
						<div class="list-times">
							<div class="list-times_item"
									 v-for="(numMinut, indexMinut) in common.alarmtime"
									 v-bind:class="{'list-times_item__active' : indexMinut === parseInt( allSettings.alarmtime / 10 -1 )}"
									 v-bind:key="indexMinut"
									 v-on:click="changeSeconds(indexMinut, 'alarmtime')" >
								<span>{{numMinut}} секунд</span>
							</div>
						</div>
						<div class="form-item">
							<div class="form-title">
								Напряжение аккумулятора
							</div>
						</div>
						<vue-slider
								ref="slider"
								v-model="allSettings.batteryalarmlevel"
								v-bind="common.sliders.batteryalarmlevel"
						></vue-slider>
						<div class="slidebar_sensivity text-small">
							Напряжение
							<span>{{allSettings.batteryalarmlevel}}V</span>
						</div>
						<div class="form-item">
							<div class="form-title">
								Кнопка # на коммандере
							</div>
							<v-select v-model="common.button2cmd.value"
												:options="common.button2cmd.list"
												label="value"
												:searchable="false"
												class="v-select_top"></v-select>
						</div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="settings-content_col">
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Передача данных от автомобиля</span>
						</div>
						<label class="settings-content_subtitle">
							Разрешить передачу данных диагностики
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbdiagenable">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">SIM карта устройства</span>
						</div>
						<div class="settings-content_subtitle">
							Ожидание ответа абонента:
						</div>
						<vue-slider
								ref="slider"
								v-model="allSettings.gsmwaitanswertimeout"
								v-bind="common.sliders.timeout"
						></vue-slider>
						<div class="slidebar_sensivity text-small">
							<span>{{allSettings.gsmwaitanswertimeout}}</span>
							сек
						</div>
						<div class="settings-content_subtitle">
							Таймаут окончания звонка при бездействии абонента:
						</div>
						<vue-slider
								ref="slider"
								v-model="allSettings.gsmhanguptimeout"
								v-bind="common.sliders.timeout"
						></vue-slider>
						<div class="slidebar_sensivity text-small">
							<span>{{allSettings.gsmhanguptimeout}}</span>
							сек
						</div>
						<div class="form-item">
							<div class="form-title">
								Запрос баланса по номеру
							</div>
							<label class="form-control form-control__empty">
								<input type="text" placeholder="*100#" class="form-field" v-model="allSettings.ussd">
							</label>
						</div>
						<label class="settings-content_subtitle">
							Разрешить передачу данных в роуминге
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbgprsroamenable">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Разрешить голосовые звонки в роуминге
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbcallroamenable">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Разрешить SMS в роуминге
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbsmsroamenable">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Поездка</span>
						</div>
						<div class="settings-content_subtitle">
							Таймаут окончания поездки:
						</div>
						<vue-slider
								ref="slider"
								v-model="allSettings.inroadtimeout"
								v-bind="common.sliders.timeoutInRoad"
						></vue-slider>
						<div class="slidebar_sensivity text-small">
								<span>
									{{Math.floor( allSettings.inroadtimeout / 60)}} мин
									{{allSettings.inroadtimeout - 60 * (Math.floor( allSettings.inroadtimeout / 60 ))}} сек</span>
							<!--<span v-if="allSettings.inroadtimeout < 60">0 мин {{allSettings.inroadtimeout}} сек</span>-->
						</div>
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Защита от захвата и иммобилайзер</span>
						</div>
						<label class="settings-content_subtitle">
							Режим защиты от захвата
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbahj">
								<div class="checkbox_img"></div>
							</div>
						</label>
						<label class="settings-content_subtitle">
							Иммобилайзер
							<div class="checkbox">
								<input type="checkbox" v-model="allSettings.cbimmobilizer">
								<div class="checkbox_img"></div>
							</div>
						</label>
					</div>
				</div>
				</perfect-scrollbar>
			</div>
			<!-- Датчики -->
			<div class="settings-section" v-if="activeSettingsItem === 5">
				<div class="options-panel_head">
					<div class="s-title text-green">
						Датчики
					</div>
					<p class="text-base">
						<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
					</p>
				</div>
				<div class="style-hr__solid">
				</div>

				<perfect-scrollbar>
					<div class="settings-content">
						<div class="settings-content_col settings-content_col__space">
							<div class="settings-content_subtitle">
								<span class="text-color-base-b2">Датчик удара</span>
							</div>
							<div class="slidebar-title">
								Предупреждение
								<label class="switcher">
									<input type="checkbox" v-model="shocks.cbshocknotify">
									<div class="switcher_checked">
										<div class="switcher_status">
										</div>
									</div>
									<div class="switcher_toddler">
									</div>
								</label>
							</div>
							<div v-bind:class="{ 'sliderDisabled' : !shocks.cbshocknotify }">
								<vue-slider
										ref="slider"
										v-model="allSettings.shocksensivity_notify"
										v-bind="common.sliders.sensivity"
								></vue-slider>
							</div>
							<div class="slidebar_sensivity text-small">
								Чувствительность:
								<span v-if="allSettings.shocksensivity_notify <= -4">Слабая</span>
								<span v-if="allSettings.shocksensivity_notify > -4 && allSettings.shocksensivity_notify < 4">Оптимальная</span>
								<span v-if="allSettings.shocksensivity_notify >= 4">Максимальная</span>
							</div>
							<div class="slidebar-title">
								Тревога
								<label class="switcher">
									<input type="checkbox" v-model="shocks.cbshockalarm">
									<div class="switcher_checked">
										<div class="switcher_status">
										</div>
									</div>
									<div class="switcher_toddler">
									</div>
								</label>
							</div>
							<div v-bind:class="{ 'sliderDisabled' : !shocks.cbshockalarm }">
								<vue-slider
										ref="slider"
										v-model="allSettings.shocksensivity_alarm"
										v-bind="common.sliders.sensivity"
								></vue-slider>
							</div>
							<div class="slidebar_sensivity text-small">
								Чувствительность:
								<span v-if="allSettings.shocksensivity_alarm <= -4">Слабая</span>
								<span v-if="allSettings.shocksensivity_alarm > -4 && allSettings.shocksensivity_alarm < 4">Оптимальная</span>
								<span v-if="allSettings.shocksensivity_alarm >= 4">Максимальная</span>
							</div>
							<div class="settings-content_subtitle">
								Время успокоения датчика удара:
							</div>
							<vue-slider
									ref="slider"
									v-model="allSettings.shockdisabletime"
									v-bind="common.sliders.shockdisabletime"
							></vue-slider>
							<div class="slidebar_sensivity text-small">
								<span>{{allSettings.shockdisabletime}} сек</span>
							</div>
						</div>
						<div class="settings-content_separator">
						</div>
						<div class="settings-content_col">
							<div class="settings-content_subtitle">
								<span class="text-color-base-b2">Датчик наклона</span>
							</div>
							<div class="slidebar-title">
								Тревога
								<label class="switcher">
									<input type="checkbox" v-model="shocks.cbmotionalarm">
									<div class="switcher_checked">
										<div class="switcher_status">
										</div>
									</div>
									<div class="switcher_toddler">
									</div>
								</label>
							</div>
							<div v-bind:class="{ 'sliderDisabled' : !shocks.cbmotionalarm }">
								<vue-slider
										ref="slider"
										v-model="allSettings.motionsensivity"
										v-bind="common.sliders.sensivity"
								></vue-slider>
							</div>
							<div class="slidebar_sensivity text-small">
								Чувствительность:
								<span v-if="allSettings.motionsensivity <= -4">Слабая</span>
								<span v-if="allSettings.motionsensivity > -4 && allSettings.motionsensivity < 4">Оптимальная</span>
								<span v-if="allSettings.motionsensivity >= 4">Максимальная</span>
							</div>
							<div class="settings-content_subtitle">
								<span class="text-color-base-b2">Режим hands-free</span>
							</div>
							<div class="slidebar-title">
								Динамик:
							</div>
							<vue-slider
									ref="slider"
									v-model="allSettings.fromgsm"
									v-bind="common.sliders.sound"
							></vue-slider>
							<div class="slidebar_sensivity text-small">
								Чувствительность:
								<span v-if="allSettings.fromgsm <= -6">Слабая</span>
								<span v-if="allSettings.fromgsm > -6 && allSettings.fromgsm < 0">Оптимальная</span>
								<span v-if="allSettings.fromgsm >= 0">Максимальная</span>
							</div>
							<div class="slidebar-title">
								Микрофон:
							</div>
							<vue-slider
									ref="slider"
									v-model="allSettings.mic"
									v-bind="common.sliders.sound"
							></vue-slider>
							<div class="slidebar_sensivity text-small">
								Чувствительность:
								<span v-if="allSettings.mic <= -6">Слабая</span>
								<span v-if="allSettings.mic > -6 && allSettings.mic < 0">Оптимальная</span>
								<span v-if="allSettings.mic >= 0">Максимальная</span>
							</div>
						</div>
					</div>
				</perfect-scrollbar>
			</div>
			<!-- Общий доступ к автомобилю -->
			<div class="settings-section" v-if="activeSettingsItem === 6">
				<div class="options-panel_head">
					<div class="s-title text-green">
						Общий доступ к автомобилю
					</div>
					<p class="text-base">
						<!--Текстовое описание Текстовое описание Текстовое описание Текстовое описание Текстовое описание-->
					</p>
				</div>
				<div class="style-hr__solid">
				</div>
				<perfect-scrollbar>
					<div class="settings-content">
					<div class="settings-content_col settings-content_col__space">
						<div v-if="share.list.length > 0">
							<div class="settings-shared_item"
									 v-for="(user, indexUser) in share.list"
									 v-bind:key="indexUser">
								<div class="form-item">
									<div class="form-title">
										Пользователь зарегистрированный в системе Universe
									</div>
									<label class="form-control form-control__empty">
										<span v-if="user.user_fio">{{user.user_fio}}</span>
										<span v-else>{{user.user_email}}</span>
									</label>
									<div class="list-notifications_importance">
										<div class="list-notifications_importance-item"
												 v-for="(type, sharedLvlIndex) in share.lvl"
												 v-bind:class="{'list-notifications_importance-item__active' : sharedLvlIndex === user.active }"
												 v-bind:key="sharedLvlIndex"
												 v-on:click="changeSharedAccess( sharedLvlIndex, indexUser, type.id )">
											<span>{{type.name}}</span>
										</div>
									</div>
									<div class="text-italic">
										Информация о текущем положении
										и состоянии автомобиля
									</div>
									<div class="text-right">
										<a href="javascript:void(0)" class="btn btn-clean" v-on:click="delUser( share.list[indexUser].id, indexUser )">Удалить пользователя</a>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="settings-operation">
								Нет добавленных пользователей
							</div>
						</div>
					</div>
					<div class="settings-content_separator">
					</div>
					<div class="settings-content_col settings-content_col__space">
						<div class="settings-content_subtitle">
							<span class="text-color-base-b2">Добавление нового пользователя</span>
						</div>
						<div class="settings-shared_item">
							<div class="form-item">
								<div class="form-title">
									Email зарегистрированного в системе Universe пользователя
								</div>
								<label class="form-control form-control__empty">
									<input type="text" placeholder="example@mail.com" class="form-field" v-model="share.newUser.user_email">
								</label>
								<div class="list-notifications_importance">
									<div class="list-notifications_importance-item"
											 v-for="(type, sharedLvlIndex) in share.lvl"
											 v-bind:key="sharedLvlIndex"
											 v-bind:class="{'list-notifications_importance-item__active' : share.newUser.active === sharedLvlIndex }"
											 v-on:click="share.newUser.id = type.id; share.newUser.active = sharedLvlIndex">
										<span>{{type.name}}</span>
									</div>
								</div>
								<div class="text-italic">
									{{share.lvl[share.newUser.active].description}}
								</div>
								<div class="text-right">
									<a href="javascript:void(0)" class="btn btn-clean" v-on:click="addNewUser()">Добавить пользователя</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				</perfect-scrollbar>
			</div>

			<!-- Preloader -->
			<transition name="fade">
				<div class="preloader" v-if="isOnline === false || saveSettingStatus === true" name="preloader">
				</div>
			</transition>
	</div>
</template>

<script>
  import MaskedInput          from  'vue-masked-input';
  import { HTTP, HTTP_COMM }  from  '../../main'
  import vueSlider            from  'vue-slider-component'
  import vSelect              from  'vue-select';
  import Datepicker from 'vuejs-datepicker';
  import {en, ru} from 'vuejs-datepicker/dist/locale'

  export default {
    data : function () {
      return{
        // Common
        common : {
          alarmtime : [10, 20, 30],
          sliders: {
            tempengine : {
              width:       320,
              height:        2,
              dotSize:      12,
              min:         -35,
              max:           0,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              piecewise:  false,
              tooltip:   'none'
            },
            tempcabinlow : {
              width:       320,
              height:        2,
              dotSize:      12,
              min:         -20,
              max:          20,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise:  false
            },
            tempcabinhigh : {
              width:       320,
              height:        2,
              dotSize:      12,
              min:          30,
              max:          60,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise:  false
            },
            batterycharge : {
              width:       320,
              height:        2,
              dotSize:      12,
              min:        10.5,
              max:          25,
              interval:    0.1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise:  false
            },
            sound : {
              width:       320,
              height:        2,
              dotSize:      12,
              min:        -7.5,
              max:         1.5,
              interval:    1.5,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise:  true
            },
            sensivity: {
              width:       320,
              height:        2,
              dotSize:      12,
              min:          -5,
              max:           5,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise:  true
            },
            batteryalarmlevel: {
              width:       320,
              height:        2,
              dotSize:      12,
              min:        10.5,
              max:          25,
              interval:    0.1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise: false
            },
            timeout: {
              width:       320,
              height:        2,
              dotSize:      12,
              min:          15,
              max:         300,
              interval:     15,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise: false
            },
            timeoutInRoad : {
              width:       320,
              height:        2,
              dotSize:      12,
              min:           5,
              max:         900,
              interval:      5,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise: false
            },
            shockdisabletime : {
              width:       320,
              height:        2,
              dotSize:      12,
              min:           0,
              max:         300,
              interval:      1,
              disabled:  false,
              show:       true,
              speed:       0.3,
              reverse:   false,
              lazy:       true,
              tooltip:  'none',
              piecewise: false
            }
          },
          button2cmd : {
            value : '',
            list : [
              { index: '0', value : 'Нет действия' },
              { index: '1', value : 'Центральный замок' },
              { index: '2', value : 'Багажник' },
              { index: '3', value : 'Управление автозапуском' }
            ]
          },
					genOptions : 0
        },
        // Таймеры
        timers : {
          nameDaysWeek: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
          timerstart : [10, 15, 20, 25, 30, 35, 40, 45],
          timerpit : [0, 10, 15, 20, 25, 30, 35, 40, 45],
          list : []
        },

        // Уведомления
        notification : {
          list : [],
					car : [],
					current : '', // P1S, P1C, P2S P2C, P3S, P3C, P4S, P4C, Email, Push
					change : {
            p1 : false,
						p2 : false,
						p3 : false,
						p4 : false
					}
        },

        // Основные
        generalSettings : {},
        firmware : {
          status : {
            need : false,
            service : 0,
            progress: 0
          },
          list : []
        },
        fuelCalibration : {
          status : false,
          calibration_info : 0,
          filling_state: 0,
          fuel : '',
          filledup : ''
        },
        passport : {
          data : {
            last_name       : "Усов",
            first_name      : "Павел",
            father_name     : "Николаевич",
            birth_date      : "1981-01-21",

            issue_country   : "Россия",
            passport_series : 6012,
            passport_number : 188258,
            authority       : "УФМС России по Гор.Москве",
            issue_date      : "2012-06-20",
            department_code : "610-009",
            is_personal_sim : true,
          },
          is_accepted : false,
          is_empty : true,
          access : 2
        },
        datepicker : {
          birthDate : {
            show : false,
            value: '',
            lang : {
              ru : ru,
              en : en
            },
            disabledDates: {
              from: new Date()
            },
            inputClass : 'form-field'
          },
          issueDate : {
            show : false,
            value: '',
            lang : {
              ru : ru,
              en : en
            },
            disabledDates: {
              from: new Date()
            },
            inputClass : 'form-field'
          }
        },
        tarif : {
          current : 'none',
          list 		: [],
          balance : 'none'
        },

        // Датчики
        shocks : {
          cbshocknotify : false,
          cbshockalarm  : false,
          cbmotionalarm : false
        },

        // Шара
        share : {
          list : [],
          lvl : [
            {
              "id": 2,
              "name": "Управление",
              "description": "Автомобилем пользуются попеременно несколько водителей. Все водители имеют равные возможности в повседневном использовании приложения. Доступ к настройкам и обновлению ПО имеет только владелец."
            },
            {
              "id": 3,
              "name": "Помощник",
              "description": "Доступ предоставляется для оказания сторонней помощи в настройках ПО. Например, Вы можете предоставить доступ нашему специалисту техподдержки или своему знакомому."
            },
            {
              "id": 4,
              "name": "Наблюдение",
              "description": "Предоставляется доступ к текущему положению автомобиля, например, членам семьи."
            },
            {
              "id": 5,
              "name": "Отчеты",
              "description": "Ответственному лицу компании предоставляются данные для составления отчетов по пробегу и расходу топлива."
            },
            {
              "id": 6,
              "name": "Мониторинг",
              "description": "Диспетчеру предоставляются данные о текущем положении автомобиля и данные для составления отчетов по пробегу и расходу топлива."
            }
          ],
          newUser : {
            active : 0,
            id: 2,
            user_email: ""
          },
        },

        // Все настройки
        allSettings : [],

				saveSettingStatus : false
      }
    },
    mounted : function () {
      this.$store.dispatch('settingPanel', 0);
      // Кидаем запрос на все настройки
      HTTP.get('cars/' + this.currentCar.id + '/device/settings/').then( (response) => {
        this.allSettings = response.data;

        this.common.button2cmd.value = this.common.button2cmd.list[this.allSettings.button2cmd];

        // Autostart
        let responseTimer = this.allSettings.remote_start_timers;
        for( let i = 0; i < responseTimer.length; i++ ){
          let hh  = parseInt( responseTimer[i].time.split(':')[0] ) - this.timeZoneVal/60;
          if( hh > 23 ){ hh = hh - 24 }
          if( hh.toString().length < 2 ){
            hh = '0' + hh
          }else{
            hh = hh.toString()
          }

          this.timers.list.push({
            status : responseTimer[i].is_active,
            hours : hh,
            minutes : responseTimer[i].time.split(':')[1],
            days : responseTimer[i].days.split(''),
            name : responseTimer[i].name
          });
        }
        // Датчики
        this.shocks.cbshocknotify = !this.allSettings.cbshocknotifydisable;
        this.shocks.cbshockalarm  = !this.allSettings.cbshockalarmdisable;
        this.shocks.cbmotionalarm = !this.allSettings.cbmotionalarmdisable;

      }).catch( ( error ) => {
        this.$store.dispatch('errorResponse', error );
      });

      this.$store.subscribeAction((action) => {
        if( action.type === 'saveSettings' ){
          this.saveSettings()
        }
      });
    },
    computed : {
      activeSettingsItem : function () {
        return this.$store.state.panels.settings
      },
      currentCar : function(){
        return this.$store.state.cars.current
      },
      user : function(){
        return this.$store.state.user
      },
      listCar(){
        return this.$store.state.cars.list;
      },
      lastCMD : function () {
        return this.$store.state.cars.lastSocket.cmd
      },
      stateCars : function(){
        return this.$store.state.cars.state
      },
      timeZoneVal(){
        return this.$store.state.timezone
      },
      isOnline : function () {
        return this.$store.state.cars.state[this.$store.state.cars.current.id].is_online
      },

			notifDetails : function () {
        let res;
        switch ( this.notification.current ){
					case 'P1S' :
					  res = this.notification.car.p1s;
						break;
					case 'P1C' :
            res = this.notification.car.p1c;
						break;
					case 'P2S' :
            res = this.notification.car.p2s;
						break;
					case 'P2C' :
            res = this.notification.car.p2c;
						break;
					case 'P3S' :
            res = this.notification.car.p3s;
						break;
					case 'P3C' :
            res = this.notification.car.p3c;
						break;
					case 'P4S' :
            res = this.notification.car.p4s;
						break;
					case 'P4C' :
            res = this.notification.car.p4c;
						break;
					case 'Email' :
            res = this.notification.car.emailN;
						break;
					case 'Push' :
            res = this.notification.car.pushN;
						break;
				}
				return res;
      }
    },
    methods : {
      // Timers
      addAutostart : function () {
        this.timers.list.splice(0, 0, {
          status : true,
          hours : '00',
          minutes : '00',
          days : ['0','0','0','0','0','0','0']
        });
      },
      changeTime : function ( index, type ) {
        if( type === 'hours' ){
          if( parseInt( this.timers.list[index].hours ) > 23 ){
            this.timers.list[index].hours = '23';
          }
        }else{
          if( parseInt( this.timers.list[index].minutes ) > 59 ){
            this.timers.list[index].minutes = '59';
          }
        }
      },
      toggleActiveDay : function ( indexAS, indexDay ) {
        if( this.timers.list[indexAS].days[indexDay] === '0' ){
          this.timers.list[indexAS].days.splice(indexDay, 1, '1');
        }else{
          this.timers.list[indexAS].days.splice(indexDay, 1, '0');
        }
      },
      delAutostart : function ( index ) {
        this.timers.list.splice( index, 1 );
      },
      changeMinut : function ( val, type ) {
        this.$set( this.allSettings, type, val );
      },

      // Notification
      getNotif: async function () {
        await this.getListNotif();
        await this.getNotifCar();
        this.formatNotifCar();
      },
			getListNotif : function(){
        return HTTP.get('events')
					.then( (response) => {
						let filterArr = response.data.filter((item) => {
							return item.has_notification
						});
						this.notification.list = filterArr.map( (item) => {
							item.Uni = 0;
							item.Mobicar = 0;

              if(  item.device_models.indexOf(1) > -1
                || item.device_models.indexOf(2) > -1
                || item.device_models.indexOf(3) > -1
                || item.device_models.indexOf(4) > -1 ){
                item.Uni = 1;
              }
              if(
                item.device_models.indexOf(13) > -1
                || item.device_models.indexOf(14) > -1 ){
                item.Mobicar = 1;
              }

							return item;
						});
					})
					.catch( (error) => {
						this.$store.dispatch('errorResponse', error );
					});
			},
			getNotifCar : function(){
				return HTTP.get('cars/' + this.currentCar.id + '/device_notifications/')
					.then( (response) => {
            this.notification.car = response.data;
					})
					.catch( (error) => {
            this.$store.dispatch('errorResponse', error );
					});
			},
			formatNotifCar : function(){
        let
					p1c = this.notification.car.phone_1_call_notifications,
					p2c = this.notification.car.phone_2_call_notifications,
					p3c = this.notification.car.phone_3_call_notifications,
					p4c = this.notification.car.phone_4_call_notifications,

					p1s = this.notification.car.phone_1_sms_notifications,
					p2s = this.notification.car.phone_2_sms_notifications,
					p3s = this.notification.car.phone_3_sms_notifications,
					p4s = this.notification.car.phone_4_sms_notifications,

					emailN = this.notification.car.email_notifications,
					pushN  = this.notification.car.push_notifications;

        this.$set(this.notification.car, 'p1c', []);
        this.$set(this.notification.car, 'p2c', []);
        this.$set(this.notification.car, 'p3c', []);
        this.$set(this.notification.car, 'p4c', []);

        this.$set(this.notification.car, 'p1s', []);
        this.$set(this.notification.car, 'p2s', []);
        this.$set(this.notification.car, 'p3s', []);
        this.$set(this.notification.car, 'p4s', []);

        this.$set(this.notification.car, 'emailN', []);
        this.$set(this.notification.car, 'pushN',  []);

        for( let i in this.notification.list ){
          let curId = this.notification.list[i].id;

          // Phone
          if( p1c.indexOf( curId ) > -1 ){
            this.notification.car.p1c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p1c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }
          if( p2c.indexOf( curId ) > -1 ){
            this.notification.car.p2c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p2c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }
          if( p3c.indexOf( curId ) > -1 ){
            this.notification.car.p3c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p3c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }
          if( p4c.indexOf( curId ) > -1 ){
            this.notification.car.p4c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p4c.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }
          // Sms
          if( p1s.indexOf( curId ) > -1 ){
            this.notification.car.p1s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p1s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }
          if( p2s.indexOf( curId ) > -1 ){
            this.notification.car.p2s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p2s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }
          if( p3s.indexOf( curId ) > -1 ){
            this.notification.car.p3s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p3s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }
          if( p4s.indexOf( curId ) > -1 ){
            this.notification.car.p4s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
          }else{
            this.notification.car.p4s.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }

          // Email
					if( emailN.indexOf( curId ) > -1 ){
            this.notification.car.emailN.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
					}else{
            this.notification.car.emailN.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }

          // Push
					if( pushN.indexOf( curId ) > -1 ){
            this.notification.car.pushN.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : true });
					}else{
            this.notification.car.pushN.push({ id : this.notification.list[i].id, name : this.notification.list[i].name, val : false });
          }

        }
			},
      changeNotifCurrent : function( arr ){
				this.notification.current = arr;
			},
			changeNotifDetails : function( item ){
				let cur = this.notification.current,
				  	arr,
						data;

        this.saveSettingStatus = true;

				if( cur === 'P1S' ){
				  data = { phone_1_sms_notifications : '' };
					arr = this.notification.car.phone_1_sms_notifications;
				}else if( cur === 'P1C' ){
          data = { phone_1_call_notifications : '' };
          arr = this.notification.car.phone_1_call_notifications;
				}else if( cur === 'P2S' ){
          data = { phone_2_sms_notifications : '' };
          arr = this.notification.car.phone_2_sms_notifications;
				}else if( cur === 'P2C' ){
					data = { phone_2_call_notifications : '' };
          arr = this.notification.car.phone_2_call_notifications;
				}else if( cur === 'P3S'){
					data = { phone_3_sms_notifications : '' };
          arr = this.notification.car.phone_3_sms_notifications;
				}else if( cur === 'P3C'){
					data = { phone_3_call_notifications : '' };
          arr = this.notification.car.phone_3_call_notifications;
				}else if( cur === 'P4S'){
					data = { phone_4_sms_notifications : '' };
          arr = this.notification.car.phone_4_sms_notifications;
				}else if( cur === 'P4C'){
					data = { phone_4_call_notifications : '' };
          arr = this.notification.car.phone_4_call_notifications;
				}else if( cur === 'Email'){
					data = { email_notifications : '' };
          arr = this.notification.car.email_notifications;
				}else if( cur === 'Push'){
					data = { push_notifications : '' };
          arr = this.notification.car.push_notifications;
				}

				if( item.val ){
          arr.push( item.id )
				}else{
				  arr.indexOf( item.id );
          arr.splice(arr.indexOf( item.id ), 1)
				}

				for( let key in data ){
				  data[key] = arr;
				}

        HTTP.patch( 'cars/' + this.currentCar.id + '/device_notifications/', data)
          .then((response) =>{
            this.notification.car = response.data;
            this.formatNotifCar();
            this.saveSettingStatus = false;
          })
          .catch( (error) => {
            this.saveSettingStatus = false;
            this.$store.dispatch('errorResponse', error );
          });
			},
      saveNotifPhone : function( inX ){
        this.saveSettingStatus = true;
        let data = {};
				if( inX === 'p1' ){
          data = { phone_1 : this.notification.car.phone_1 };
          this.notification.change.p1 = false;
				}else if( inX === 'p2' ){
          data = { phone_2 : this.notification.car.phone_2 };
          this.notification.change.p2 = false;
				}else if( inX === 'p3' ){
          data = { phone_3 : this.notification.car.phone_3 };
          this.notification.change.p3 = false;
				}else if( inX === 'p4'){
          data = { phone_4 : this.notification.car.phone_4 };
          this.notification.change.p4 = false;
				}

        HTTP.patch( 'cars/' + this.currentCar.id + '/device_notifications/', data)
					.then((response) =>{
            this.notification.car = response.data;
            this.formatNotifCar();
						this.saveSettingStatus = false;
					})
					.catch( (error) => {
						this.saveSettingStatus = false;
						this.$store.dispatch('errorResponse', error );
					});
      },
      changePhone : function( inX ){
        this.notification.change.p1 = false;
        this.notification.change.p2 = false;
        this.notification.change.p3 = false;
        this.notification.change.p4 = false;
        this.notification.change[inX] = true;
			},

      // General
      getGeneral : function () {
        if( Object.keys(this.generalSettings).length === 0 ){
          let _this = this;
          // Основные настройки
          if( this.stateCars[this.currentCar.id].state === "service" ){
            this.firmware.status.service = 1;
          }

          HTTP.get('cars/' + this.currentCar.id + '/device/').then( function(response){
            _this.generalSettings = response.data;
          }).catch( function( error ) {
            _this.$store.dispatch('errorResponse', error );
          });
          // Версии ПО
          if( _this.listCar[_this.currentCar.index].access_firmware ){
            HTTP.get('cars/' + this.currentCar.id + '/firmware/').then( function(response){
              _this.firmware.list = response.data;
              _this.firmware.status.need = false;
              for( let i = 0; i < response.data.length; i++ ){
                if( response.data[i].update !== null ){
                  _this.$set( _this.firmware.list[i], 'progress', 0 );
                  _this.firmware.status.need = true;
                  break;
                }
              }
            }).catch( function( error ){
              _this.$store.dispatch('errorResponse', error );
            });
          }
          // Датчики топлива
          HTTP.get('cars/' + this.currentCar.id + '/fuel_calibration/').then( function(response){
            _this.fuelCalibration.status = true;
            _this.fuelCalibration.calibration_info = response.data.calibration_info;
            _this.fuelCalibration.filling_state = response.data.filling_state;
          }).catch(function ( error ){
            _this.$store.dispatch('errorResponse', error );
          });
          // Паспортные данные
          HTTP_COMM.get( '/core/v1/cars/' + this.currentCar.id + '/device/passport/' )
            .then( response => {
              this.passport.is_empty = false;
              this.passport.is_accepted = false;
              this.passport.access = 1;

              this.passport.data = {
                last_name       : "",
                first_name      : "",
                father_name     : "",
                birth_date      : "",

                issue_country   : "",
                passport_series : "",
                passport_number : "",
                authority       : "",
                issue_date      : "",
                department_code : "",
                is_personal_sim : response.data.is_personal_sim,
              }
            })
            .catch( (error) => {
              if( error.response.status === 403 ){
                this.passport.access = 2;
							}else if( error.response.status === 404 ){
                this.passport.access = 0;
							}

              this.passport.is_empty = true;

              this.passport.data = {
                last_name       : "",
                first_name      : "",
                father_name     : "",
                birth_date      : "",

                issue_country   : "",
                passport_series : "",
                passport_number : "",
                authority       : "",
                issue_date      : "",
                department_code : "",
                is_personal_sim : false,
              };
            });
          // Тарифы
					this.getTarif();
        }
      },
      getTarif : async function(){
        await HTTP.get('cars/' + this.currentCar.id + '/device/operator/?service_type=tariff_all')
          .then( response => {
            this.tarif.list = response.data;
          })
          .catch(error => {
            this.tarif.list = [];
            console.log( error );
          });
        await HTTP.get('cars/' + this.currentCar.id + '/device/operator/?service_type=tariff')
          .then( response => {
            this.tarif.current = response.data;
          })
          .catch(error => {
            this.tarif.current = 'none';
						console.log( error );
          });

        await HTTP.get('cars/' + this.currentCar.id + '/device/operator/?service_type=balance')
          .then( response => {
            this.tarif.balance = response.data;
          })
          .catch(error => {
            this.tarif.balance = 'none';
            console.log( error );
          });
      },
			changeTarif : function( id ){
				HTTP.post( 'cars/' + this.currentCar.id + '/device/operator/',
          {
            service_type : "tariff",
            tariff_id : id
          })
					.then( () => {
						this.getTarif();
            this.$store.dispatch( 'addAlert', { text : 'Тариф изменен', type : 'success' });
					})
					.catch( error => {
            this.$store.dispatch('errorResponse', error );
					});
			},
      sendfuelCalibration : function () {

      },
      sendPersonalData : function () {
        let a = this.passport.data,
            result = true;

        switch ( '' ){
          case a.last_name.replace(/\s/g, '') :
            this.$store.dispatch( 'addAlert', { text : 'Поле "Фамилия" заполнено неверно', type : 'error' });
            result = false;
            break;
          case a.first_name.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Поле "Имя" заполнено неверно', type : 'error' });
            result = false;
            break;
          case a.father_name.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Поле "Отчество" заполнено неверно', type : 'error' });
            result = false;
            break;
          case a.birth_date.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Не указана дата рождения', type : 'error' });
            result = false;
            break;
          case a.issue_country.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Поле "Страна" заполнено неверно', type : 'error' });
            result = false;
            break;
          case a.passport_series.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Поле "Сария паспорта" заполнено неверно', type : 'error' });
            result = false;
            break;
          case a.passport_number.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Поле "Номер паспорта" заполнено неверно', type : 'error' });
            result = false;
            break;
          case a.authority.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Поле "Кем выдан" заполнено неверно', type : 'error' });
            result = false;
            break;
          case a.issue_date.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Не указана дата выдачи паспорта', type : 'error' });
            result = false;
            break;
          case a.department_code.replace(/\s/g, ''):
            this.$store.dispatch( 'addAlert', { text : 'Поле "Код подразделения" заполнено неверно', type : 'error' });
            result = false;
            break;
          default:
            result = true;
        }

        if( result ){
          if( this.passport.is_empty ){
            HTTP_COMM.post( '/core/v1/cars/' + this.currentCar.id + '/device/passport/', a )
              .then( () => {
                this.$store.dispatch( 'addAlert', { text : 'Данные сохранены', type : 'success' });
              })
              .catch( error => {
                this.$store.dispatch('errorResponse', error );
              })
            ;
          }else{
            HTTP_COMM.put( '/core/v1/cars/' + this.currentCar.id + '/device/passport/', a )
              .then( () => {
                this.$store.dispatch( 'addAlert', { text : 'Данные сохранены', type : 'success' });
              })
              .catch( error => {
                this.$store.dispatch('errorResponse', error );
              })
            ;
          }
        }
      },

      openDatapickerBirthdate : function(){
        this.datepicker.birthDate.show = true;
      },
      closeDatapickerBirthdate : function(){
        this.datepicker.birthDate.show = false;
      },
      datepickerFormatterBirthDate : function ( date ) {
        this.passport.data.birth_date = this.$moment( date ).format('YYYY-MM-DD');
        this.datepicker.birthDate.show = false;
      },

      openDatapickerIssuedate : function () {
        this.datepicker.issueDate.show = true;
      },
      closeDatapickerIssuedate : function(){
        this.datepicker.issueDate.show = false;
      },
      datepickerFormatterIssuedate : function( date ){
        this.passport.data.issue_date = this.$moment( date ).format('YYYY-MM-DD');
        this.datepicker.issueDate.show = false;
      },

      // Guard System
      changeSeconds : function ( index, type ) {
        this.$set( this.allSettings, type, (index + 1) * 10  );
      },

      // Share
      getShare : function () {
        let _this = this;
        if( _this.share.list.length === 0 ){
          HTTP.get('cars/' + this.currentCar.id + '/shares/').then( function(response){
            let settingsShared = response.data;

            for( let i = 0; i < response.data.length; i++ ){
              settingsShared[i].active = response.data[i].role-2;
            }
            _this.share.list = settingsShared;
          }).catch(function ( error ) {
            _this.$store.dispatch('errorResponse', error );
          });
        }
      },
      addNewUser : function () {
        let _this = this;
        if( this.share.newUser.user_email === "" ){
          _this.$store.dispatch( 'addAlert', { text : 'Заполните Email пользователя', type : 'error' });
        }else{
          HTTP.post('cars/' + this.currentCar.id + '/shares/', {
            "user": this.share.newUser.user_email,
            "role": this.share.newUser.id
          }).then( function( response ){
            _this.$store.dispatch( 'addAlert', { text : 'Пользователь добавлен', type : 'success' });
            _this.share.list.push( response.data );
          }).catch(function ( error ) {
            _this.$store.dispatch('errorResponse', error );
          });
        }
      },
      changeSharedAccess : function ( indlvl, indUser, id ) {
        let _this = this;
        this.share.list[indUser].active = indlvl;

        //  car_id  share_id
        HTTP.patch('cars/' + this.currentCar.id + '/shares/' + this.share.list[indUser].id + '/', {
          "role": id
        }).then( function(){
          _this.$store.dispatch( 'addAlert', { text : 'Изменения сохранены', type : 'success' });
        }).catch(function ( error ) {
          _this.$store.dispatch('errorResponse', error );
        });
      },
      delUser : function ( id, userIndex ) {
        let _this = this;
        HTTP.delete('cars/' + this.currentCar.id + '/shares/' + id + '/').then( function(){
          _this.share.list.splice( userIndex, 1 );
          _this.$store.dispatch( 'addAlert', { text : 'Пользователь удален', type : 'success' });
        }).catch(function ( error ) {
          _this.$store.dispatch('errorResponse', error );
        });
      },

      // Send Command
      sendCommand : function ( command ){
        HTTP.post('cars/' + this.currentCar.id + '/command/', {
          car_id : this.currentCar.id,
          cmd: command
        }).then( () => {
          if( command !== 'update_settings' ){
          	this.$store.dispatch( 'addAlert', { text : 'Отправлена комманда: ' + command, type : 'success' });
					}
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },

      // Save Settings
      saveSettings : function () {
        let _this = this;

        // Собираем таймеры
        let arrTimers = [];
        for( let i = 0; i < this.timers.list.length; i++ ){
          let hh = parseInt(this.timers.list[i].hours) + this.timeZoneVal/60;
          if( 24 + hh < 24 ){ hh = 24 + hh }
          if( hh.toString().length < 2 ){
            hh = '0' + hh
          }else{
            hh = hh.toString()
          }

          arrTimers.push({
            is_active : this.timers.list[i].status,
            days : this.timers.list[i].days.toString().replace(/,/g, ''),
            time : hh + ":" + this.timers.list[i].minutes,
            name : this.timers.list[i].name
          });
        }
        this.allSettings.remote_start_timers = arrTimers;

        // Собираем кнопку на командере
        this.allSettings.button2cmd = this.common.button2cmd.value.index;


        // Датчики
        this.allSettings.cbshocknotifydisable = !this.shocks.cbshocknotify;
        this.allSettings.cbshockalarmdisable  = !this.shocks.cbshockalarm;
        this.allSettings.cbmotionalarmdisable = !this.shocks.cbmotionalarm;


        let collectNottification = function(){
          // Отправка оповещений
          if( _this.notification.events && _this.notification.events.length ){
            // Собираем оповещения
            _this.notification.list[0].notifications = [];
            _this.notification.list[1].notifications = [];
            for( let i = 0; i < _this.notification.events.length; i++ ){
              if( parseInt( _this.notification.events[i].importance ) === 1 ){
                if( _this.notification.list[0].importance === "Обычное" ){
                  _this.notification.list[0].notifications.push( _this.notification.events[i].id );
                }else{
                  _this.notification.list[1].notifications.push( _this.notification.events[i].id );
                }
              }else if( parseInt( _this.notification.events[i].importance ) === 2 ){
                if( _this.notification.list[1].importance === "Важное" ){
                  _this.notification.list[1].notifications.push( _this.notification.events[i].id );
                }else{
                  _this.notification.list[0].notifications.push( _this.notification.events[i].id );
                }
              }
            }
            // Собираем телефоны
            for( let i = 0; i < _this.notification.phones.length; i++ ){
              for( let j = 0; j < _this.notification.list[0].phones.length; j++){
                if( _this.notification.list[0].importance === "Обычное" ){
                  if( _this.notification.list[0].phones[j].id === _this.notification.phones[i].id ){
                    _this.notification.list[0].phones[j].is_call_allowed = _this.notification.phones[i].isCallAllowedNormal;
                    _this.notification.list[0].phones[j].is_sms_allowed = _this.notification.phones[i].isSmsAllowedNormal;
                    _this.notification.list[1].phones[j].is_call_allowed = _this.notification.phones[i].isCallAllowedImportant;
                    _this.notification.list[1].phones[j].is_sms_allowed = _this.notification.phones[i].isSmsAllowedImportant;
                  }
                }else{
                  _this.notification.list[1].phones[j].is_call_allowed = _this.notification.phones[i].isCallAllowedNormal;
                  _this.notification.list[1].phones[j].is_sms_allowed = _this.notification.phones[i].isSmsAllowedNormal;
                  _this.notification.list[0].phones[j].is_call_allowed = _this.notification.phones[i].isCallAllowedImportant;
                  _this.notification.list[0].phones[j].is_sms_allowed = _this.notification.phones[i].isSmsAllowedImportant;
                }
              }
            }
            // Отправляем
            HTTP.patch('cars/' + _this.currentCar.id + '/notifications/' + _this.notification.list[0].id + '/', _this.notification.list[0] ).then( function(){
              HTTP.put('cars/' + _this.currentCar.id + '/notifications/' + _this.notification.list[1].id + '/', _this.notification.list[1] ).then( function(){
                _this.sendCommand('update_settings');
              }).catch(function ( error ) {
                _this.$store.dispatch('errorResponse', error );
              });
            }).catch(function ( error ) {
              _this.$store.dispatch('errorResponse', error );
            });
          }else{
            _this.sendCommand('update_settings');
          }
        };


        // Все настройки
        HTTP.patch('cars/' + this.currentCar.id + '/device/settings/', this.allSettings ).then( () => {
          // Настройки устройства
          if( Object.keys( this.generalSettings ).length ){
            HTTP.patch('cars/' + this.currentCar.id + '/device/', this.generalSettings ).then( () => {
              collectNottification();
            }).catch( ( error ) => {
              this.$store.dispatch('errorResponse', error );
            });
          }else{
            collectNottification();
          }
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      }
    },
    watch : {
      'activeSettingsItem' : function ( settingsIndex ) {
        // Уведомления от охранной системы
        if( settingsIndex === 1 ){
          this.getNotif();
        }else if( settingsIndex === 2 ){
          this.getGeneral();
        }else if( settingsIndex === 6 ){
          this.getShare();
        }
      },
      lastCMD : function ( newVal ) {
        if( newVal.car_id === this.currentCar.id ){

          if( newVal.data.cmd === "service_start" && newVal.data.state === "SUCCESS" ){
            this.firmware.status.service = 1;
          }
          // Обновление прошивки
          if( newVal.data.cmd === "update_firmware" ){
            if( newVal.data.state === "START" ){
              this.firmware.status.service = 2;
            }else if( newVal.data.state === 'INPROCESS' ){
              for( let i = 0; i < this.firmware.list.length; i++ ){
                for( let j = 0; j < newVal.data.cores.length; j++ ){
                  if( this.firmware.list[i].pcb_type === newVal.data.cores[j].pcb_type ){
                    this.firmware.list[i].progress = newVal.data.cores[j].percent;
                  }
                }
              }
              this.firmware.status.progress = newVal.data.cores[newVal.data.cores.length-1].percent;
            }else if( newVal.data.state === "SUCCESS" ){
              this.firmware.status.service = 3;

              HTTP.get('cars/' + this.currentCar.id + '/firmware/').then( response => {
                this.firmware.list = response.data;
                for( let i = 0; i < response.data.length; i++ ){
                  if( response.data[i].update !== null ){
                    this.$set( this.firmware.list[i], 'progress', 0 );
                    break;
                  }
                }
              }).catch( error => {
                this.$store.dispatch('errorResponse', error );
              });
            }
          }

          // Сохранение настроек
					if( newVal.data.cmd === "update_settings" ){
            if( newVal.data.state === 'START' || newVal.data.state === 'INPROCESS' ) {
							this.saveSettingStatus = true;
            }else if( newVal.data.state === 'SUCCESS' ){
              this.saveSettingStatus = false;
              this.$store.dispatch( 'addAlert', { text : 'Настройки сохранены', type : 'success' });
						}else if( newVal.data.state === 'FAIL' ){
              this.saveSettingStatus = false;
							console.log( newVal.data );
						}
					}
        }
      }
    },
    components : {
      MaskedInput,
      vueSlider,
      vSelect,
      Datepicker
    }
  }
</script>